import axios from 'axios'

export const getTeamProjects = async ({ id }) => {
  const url = process.env.REACT_APP_ADMIN_API + `/projects/${id}`
  const response = await axios.get(url, {})
  return response.data.vercelResponse
}
